import { getLocalizationObject } from "@/router/helpers";
import { autodetectCountryCode, setCountry } from "@/services/translation";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const storeLocalizationInApp = async (to: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  const localization = getLocalizationObject(to);
  if (localization) {
    await setCountry(localization.country);
    return next();
  } else {
    const url = "/" + autodetectCountryCode() + to.fullPath;
    return next(url);
  }
};
